module.exports = __webpack_public_path__ + "static/media/biom-mass-server-favicon.c801632f.png";


//////////////////
// WEBPACK FOOTER
// ./src/packages/@ncigdc/theme/images/biom-mass-server-favicon.png
// module id = 1538
// module chunks = 31